import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { OrderService } from 'src/app/services/order.service';
import { getCurrencySymbol } from '@angular/common';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { Subscription } from 'rxjs';
import { CurrencyService } from 'src/app/services/currency.service';
import { BrowserStorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-prepaids',
  templateUrl: './prepaids.component.html',
  styleUrls: ['./prepaids.component.scss']
})
export class PrepaidsComponent implements OnInit, OnDestroy {
  addPrepaidForm: FormGroup;
  prepaidCodes: Array<any> = [];
  listLoading: boolean;
  currencySymbol;
  currencySubscription: Subscription;
  selectedCurrency;

  constructor(
    private formBuilder: FormBuilder,
    private orderService: OrderService,
    private httpAlertService: HttpAlertService,
    private currencyService: CurrencyService,
    private browserStorageService: BrowserStorageService,
    ) {
    this.addPrepaidForm = this.formBuilder.group({
      value: ['', Validators.required],
      expired_date: [Date.now, Validators.required],
      codes_amount: [1, [Validators.required, Validators.min(1)]]
    });
  }

  ngOnInit(): void {
    this.fetchPrepaidCodes();
    this.getCurrency();

    this.currencySubscription = this.currencyService.currencyChangeEmitter.subscribe((name: string) => {
      this.getCurrency();
    });
  }

  ngOnDestroy(): void {
    this.currencySubscription.unsubscribe();
  }

  private fetchPrepaidCodes() {
    this.listLoading = true;
    this.orderService.getPrepaidCodes().subscribe(response => {
      if (response.success) {
        this.prepaidCodes = response.data;
      }
      this.listLoading = false;
    });
  }

  private getCurrency() {
    this.selectedCurrency = this.browserStorageService.get("_currency");
    this.currencySymbol = getCurrencySymbol(this.selectedCurrency, "narrow");
  }

  submitPrepaidForm() {
    if (this.addPrepaidForm.valid) {
      this.orderService.addPrepaidCode(this.addPrepaidForm.value).subscribe(response => {
        if (response.success) {
          this.httpAlertService.success('Dodano');
          this.fetchPrepaidCodes();
        } else {
          this.httpAlertService.warn(response.message);
        }
      });
    }
  }

}
